export default __webpack_public_path__ + "static/media/pdf.d97cef27.svg";